module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header",
    style: (_vm.bjStyle)
  }, [(_vm.locale == 'ch') ? _c('img', {
    staticClass: "header-img",
    attrs: {
      "src": require("../imgs/banner_cn.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.locale == 'en') ? _c('img', {
    staticClass: "header-img",
    attrs: {
      "src": require("../imgs/sectop.png")
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "leftPad"
  }, [_c('span', {
    staticClass: "idx_title",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v(_vm._s(_vm.$t("sIndex.index")))]), _c('span', {
    staticClass: "fx"
  }, [_vm._v(">")]), _c('span', {
    staticClass: "s_title"
  }, [_vm._v(_vm._s(_vm.$t("sIndex.sign")))]), _vm._v(" "), _c('span', {
    class: {
      ch_mg: _vm.locale == 'ch', en_mg: _vm.locale == 'en'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.locale == "en" ? "Welcome" : "欢迎"))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "5px",
      "padding-right": "5px"
    }
  }, [_vm._v(_vm._s(_vm.user.uName == null || _vm.user.uName == '' ? (_vm.locale == 'en' ? "" : "您") : _vm.user.uName.length > 12 ? _vm.uName.subStr(0, 12) + "..." : _vm.user.uName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale == "en" ? "to register" : "登录报名系统"))])])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "step"
  }, [_c('span', {
    class: {
      active: _vm.activeTab == '0'
    }
  }, [_vm._v(_vm._s(_vm.$t("sIndex.step1")))]), _c('span', [_vm._v("---")]), _c('span', {
    class: {
      active: _vm.activeTab == '1'
    }
  }, [_vm._v(_vm._s(_vm.$t("sIndex.step2")))]), _c('span', [_vm._v("---")]), _c('span', {
    class: {
      active: _vm.activeTab == '2'
    }
  }, [_vm._v(_vm._s(_vm.$t("sIndex.step3")))]), _c('span', [_vm._v("---")]), (_vm.locale == 'ch') ? _c('span', {
    class: {
      active: _vm.activeTab == '3'
    }
  }, [_vm._v(_vm._s(_vm.$t("sIndex.step4")))]) : _vm._e(), (_vm.locale == 'ch') ? _c('span', [_vm._v("---")]) : _vm._e(), _c('span', {
    class: {
      active: _vm.activeTab == '4'
    }
  }, [_vm._v(_vm._s(_vm.$t("sIndex.step5")))]), _c('span', [_vm._v("---")]), _c('span', {
    class: {
      active: _vm.activeTab == '5'
    }
  }, [_vm._v(_vm._s(_vm.$t("sIndex.step6")))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "80px"
    }
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-517d385d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/s_index.vue
// module id = 802
// module chunks = 10